export const ALL_FILTER_VALUE = '__all__'
